const colorMap = {
  "Blue": "#0000ff",
  "Sky": "#87cfeb",
  "White": "#ffffff",
  "Red": "#ff0000",
  "Others": "#808080",
  "Pink": "#ffc0cb",
  "Black": "#000000",
  "Navy": "#000080",
  "Green": "#00ff00",
  "Cream": "#fffdd0",
  "Beige": "#f5f5dc",
  "Brown": "#964b00",
  "Yellow": "#ffff00",
  "Lilac": "#c8a2c8",
  "Maroon": "#800000",
  "Orange": "#ffa600",
  "Light Grey": "#d3d3d3",
  "Olive": "#808000",
  "Purple": "#a020f0",
  "Dark Grey": "#a9a9a9",
  "Sand": "#c2b180",
  "Black & White": "#000000",
  "Rust": "#b7410e",
  "Gold": "#ffd900",
  "Ochre": "#cc7722",
  "Teal": "#008080",
  "Grey": "#808080",
  "Ink": "#27221f",
  "Lime": "#00ff00",
  "Turquoise": "#40e0d0",
  "Anthra": "#353c40",
  "Aqua": "#00ffff",
  "Mustard": "#ffdb58",
  "Sea Green": "#2e8b56",
  "Burgundy": "#800020",
  "Cobalt": "#0047ab",
  "Mint": "#3eb489",
  "Chocolate": "#7b4000",
  "Coral": "#ff7f50",
  "Dark Pink": "#aa336a",
  "Dark Red": "#8b0000",
  "Ecru": "#c2b180",
  "Khaki": "#f0e68c",
  "Dark Blue": "#00008b",
  "Dark Maroon": "#3c0008",
  "Medium Grey": "#a9a9a9",
  "Rose": "#ff0080",
  "Stone": "#ada587",
  "Camel": "#c19a6b",
  "Charcoal": "#36454f",
  "Medium Red": "#8b0000",
  "Peach": "#ffe5b4",
  "Royal": "#4169e1",
  "Tangerine": "#f28500",
  "Aubergine": "#614051",
  "Dark Brown": "#654321",
  "Dark Gold": "#ffd900",
  "Dark Green": "#013220",
  "Dark Olive": "#556b2f",
  "Jade": "#00a86a",
  "Light Blue": "#add8e6",
  "Light Brown": "#c4a484",
  "Medium Blue": "#0000cd",
  "Medium Brown": "#7f5212",
  "Silver": "#c0c0c0",
  "Tan": "#d2b48c",
  "Wine": "#722f37"
};



window.onWizzyScriptLoaded = function () {


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      console.log(payload, "BEFORE_LAZY_INIT");
      payload.search.configs.facets.leftFacets.mobileCollapsible = true;
      window.wizzyConfig.filters.configs.layout = "v1";
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      payload.search.configs.pagination.appendInExistingList=true;

      payload.search.configs.pagination.infiniteScrollOffset = {
        desktop: 3e3,
        mobile: 2e3
      }

      return payload;
    }
  );


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      console.log(payload, "BEFORE_INIT");
      payload.search.configs.facets.leftFacets.mobileCollapsible = true;
      window.wizzyConfig.filters.configs.layout = "v1";
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      payload.search.configs.pagination.appendInExistingList=true;
    //   window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
    //     {
    //         "dom": "wizzy-search-input",
    //         "type": "text"
    //     }
    //   ]
    //   window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")

    payload.search.configs.pagination.infiniteScrollOffset = {
      desktop: 3e3,
      mobile: 2e3
    }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")   
    
      payload.forEach(product => {

        product.colorSwatch = "";
        product.handle = "";
        product.fitValue = "";
        product.newArrival = false;
        product.bestSeller = false;

        if(product.attributes){
          product.attributes.forEach(attribute => {
            if(attribute.id === "product_similar_product__custom"){
              if(attribute.values?.[0]?.value?.[0]){
                const productData = JSON.parse(attribute.values[0].value[0]);
                const filteredProducts = [];

                // console.log(productData, "wizzy product data");

                productData.forEach(gid => {
                  const productId = gid.split("/").pop();
                  const productInfo = window.storeProducts[productId];

                  if (productInfo) {
                    filteredProducts.push({
                      product_url: productInfo.url,
                      product_image: productInfo.image,
                      count_present : false
                    });
                  }
                });

                const totalCount = filteredProducts.length;
                const finalProducts = filteredProducts.slice(0, 4);

                if (totalCount > 4) {
                  finalProducts.push({
                    product_url: product.url,
                    count: totalCount,
                    count_present : true
                  });
                }

                product.colorSwatch = finalProducts;
                // product.colorSwatch = filteredProducts;
                // console.log(finalProducts, "filtered products (url & image only)");

              }
            }
            if(attribute.id === "product_handle"){
              if(attribute.values?.[0]?.value?.[0]){
                product.handle = attribute.values[0].value[0];
              }
            }
            if(attribute.id === "product_fit_custom"){
              if(attribute.values?.[0]?.value?.[0]){
                product.fitValue = attribute.values[0].value[0];
              }
            }
            if(attribute.id === "product_best_seller_custom"){
              if(attribute.values?.[0]?.value?.[0] && attribute.values[0].value[0] === "Yes"){
                product.bestSeller = true;
              }
            }
            if(attribute.id === "product_new_arrivals_custom"){
              if(attribute.values?.[0]?.value?.[0] && attribute.values[0].value[0] === "Yes"){
                product.newArrival = true;
              }
            }
          });
        }
      });

      payload.forEach((product) => {
        if (
          (product.price &&
            product.price.endsWith(".00") &&
            (product.price = product.price.slice(0, -3)),
          product.sellingPrice &&
            product.sellingPrice.endsWith(".00") &&
            (product.sellingPrice = product.sellingPrice.slice(0, -3)),
          product.discount)
        ) {
          product.discount.endsWith(".00") &&
            (product.discount = product.discount.slice(0, -3));
          // var discountPrice = product.discount;
          // discountPrice && (product.discount = discountPrice.replace(/,/g, ""))
        }
      });
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      // payload.minQueryLength = 1;
      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      return data;
    })

     window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (payload) {
        // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
        return payload;
      }
    );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_SEARCH_EXECUTED")

      payload.attributeFacetValuesLimit = 50;

      if(payload.sort) {
        console.log(payload.sort);
        if(payload.sort.length > 0){
          if(payload.sort[0].field === "relevance"){
            payload.sort = [
                {
                  "field": "relevance",
                  "order": "asc"
                },
                {
                  "field": "sellingPrice",
                  "order": "asc",
                  "isForParent": "false",
                  "isForVariation": "true"
                }
            ]
          }
        }
      }

      const productModal = document.querySelector('product-modal');
      if (productModal) {
        productModal.remove();
      }

      const productModals = document.querySelectorAll('product-modal');
      productModals.forEach(modal => {
        modal.remove();
      });

      const hero = document.querySelector('.collection-hero');
      if (hero) {
        // hero.remove();
        hero.style.display = 'none';
      }

      return payload;
    }
  );

     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");    
      
      payload.filters.attributeFacetValuesLimit = 50;

      if(payload.filters.origin){
        console.log(payload.filters.origin, "wizzy origin")
        if(payload.filters.origin === "SORT"){
          document.documentElement.classList.add('wizzy-overlay-opened');
          console.log("wizzy class added");
        }
      }
      
      if(payload.filters.sort) {
        // console.log(payload.filters.sort);
        if(payload.filters.sort[0].field === "relevance"){
          payload.filters.sort = [
              {
                "field": "relevance",
                "order": "asc"
              },
              {
                "field": "sellingPrice",
                "order": "asc",
                "isForParent": "false",
                "isForVariation": "true"
              }
          ]
        }
      }

      if(payload.filters.sort) {
        const collectionHandle = window.wizzyConfig.common.categoryUrlKey;
        const field =`product_${collectionHandle}_sortOrder:float`
        console.log(collectionHandle, field, "wizzy sort order");
        if(payload.filters.sort[0].field === "relevance" && window.wizzyConfig.common.isOnCategoryPage){
          payload.filters.sort = [
              {
                "field": "relevance",
                "order": "asc"
              },
              {
                "field": field,
                "order": "asc"
              },
              {
                "field": "sellingPrice",
                "order": "asc",
                "isForParent": "false",
                "isForVariation": "true"
              }
          ]
        }
      }

      const scrollTriggers = document.querySelectorAll('.scroll-trigger');
      scrollTriggers.forEach(el => {
        if (el.classList.contains('animate--slide-in')) {
          el.classList.remove('animate--slide-in');
        }
      });
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      console.log(data," <= VIEW_RENDERED");

      initializeButtonClicks();

      if ((data.data.api === "search" || data.data.api === "filter") && data.data.response.payload.total !== 0) {

        //////////////////////////////////////////////////////////////////////////////////////////////

        const productTypeFacet = document.querySelector('.wizzy-facet-list-block .wizzy-filters-facet-block[data-key="product_apparel_custom"]');
        const plpLeftPanel = document.querySelector('.wizzy-search-wrapper .wizzy-quick-filter');

        if (productTypeFacet && plpLeftPanel) {
            const clonedFacet = productTypeFacet.cloneNode(true);

            const facetHead = clonedFacet.querySelector('.wizzy-facet-head');
            const facetSearch = clonedFacet.querySelector('.facet-search-wrapper');
            if (facetHead) facetHead.remove();
            if(facetSearch) facetSearch.remove();

            plpLeftPanel.innerHTML = ''; // Clear existing content
            plpLeftPanel.appendChild(clonedFacet); // Append the cloned facet
        }

        // const plpLeftPanelMobile = document.querySelector('.wizzy-search-results-wrapper .plp_left_side.mobile .plp_sidebar_inner');
        // if (productTypeFacet && plpLeftPanelMobile && document.documentElement.clientWidth < 768) {
        //     const clonedFacet = productTypeFacet.cloneNode(true);
        //     plpLeftPanelMobile.innerHTML = ''; // Clear existing content
        //     plpLeftPanelMobile.appendChild(clonedFacet); // Append the cloned facet
        // }

        //////////////////////////////////////////////////////////////////////////////////////////////

        const productTypeBrandFacet = document.querySelector('.wizzy-facet-list-block .wizzy-filters-facet-block[data-key="brands"]');
        const plpLeftBrandhPanel = document.querySelector('.wizzy-search-wrapper .wizzy-brand-quick-filter');

        if (productTypeBrandFacet && plpLeftBrandhPanel) {
            const clonedBrandFacet = productTypeBrandFacet.cloneNode(true);

            const facetBrandhHead = clonedBrandFacet.querySelector('.wizzy-facet-head');
            const facetBrandSearch = clonedBrandFacet.querySelector('.facet-search-wrapper');
            if (facetBrandhHead) facetBrandhHead.remove();
            if(facetBrandSearch) facetBrandSearch.remove();

            plpLeftBrandhPanel.innerHTML = ''; // Clear existing content
            plpLeftBrandhPanel.appendChild(clonedBrandFacet); // Append the cloned facet
        }

      }


      const brandWrapper = document.querySelector('.wizzy-brand-quick-filter');

      if (brandWrapper) {
        const svgMap = {
          _ZODIAC: 'https://cdn.shopify.com/s/files/1/0958/7353/1977/files/ZODIAC_a938e0de-3f76-4cd2-b897-d4448e54158b.svg',
          _z3: 'https://cdn.shopify.com/s/files/1/0958/7353/1977/files/z3_1d5b0c77-698f-4163-989f-6969a5a13515.svg',
          _ZOD_: 'https://cdn.shopify.com/s/files/1/0958/7353/1977/files/ZOD_362dcfe0-9e73-4d88-967d-87a9cc59f9d1.svg'
        };

        Object.keys(svgMap).forEach(key => {
          const item = brandWrapper.querySelector(
            `.wizzy-facet-list-item[data-key="${key}"]`
          );

          if (item) {
            const label = item.querySelector('.wizzy-facet-list-item-label');

            if (label && !item.querySelector('.brand-svg')) {
              const img = document.createElement('img');
              img.src = svgMap[key];
              img.alt = key;
              img.className = 'brand-svg';
              // img.style.marginRight = '6px';
              // img.style.height = '16px';
              // img.style.verticalAlign = 'middle';

              label.prepend(img);
            }
          }
        });
      }


      const appliedFilter = document.querySelector(".wizzy-selected-filters");
      if(appliedFilter){
        if(appliedFilter.children.length > 0){
          const applyButton = document.querySelector(".wizzy-apply-btn");
          if(applyButton){
            applyButton.classList.add("active");
          }
        }else{
          console.log("No wizzy filter applied");
        }
      }

      setTimeout(() => {
        const productModals = document.querySelectorAll('product-modal');
        productModals.forEach(modal => {
          modal.remove();
        });
      }, 200);

      setTimeout(() => {
        const scrollTriggers = document.querySelectorAll('#MainContent .scroll-trigger');
        scrollTriggers.forEach(el => {
          if (el.classList.contains('animate--slide-in')) {
            el.classList.remove('animate--slide-in');
          }
        });
      }, 800);

      if (data.data.api === "search" && data.data.response.payload.total !== 0) {
        // Get the element
        setTimeout(() => {
          const wizzyEl = document.querySelector('.wizzy-search-wrapper');
          if (wizzyEl) {
            const scrollTriggerParent = wizzyEl.closest('.scroll-trigger');
            if (scrollTriggerParent && scrollTriggerParent.classList.contains('page-width')) {
              scrollTriggerParent.classList.remove('page-width');
            }
          }
        }, 500);
      }

      if ((data.data.api === "filter" || data.data.api === "search") && data.data.response.payload.total !== 0) {
        // removed condtion && window.wizzyConfig.common.isOnCategoryPage
        const totalProducts = data.data.response.payload.total;
        // console.log(totalProducts, "data.data.response.payload.total");

        const summaryContainer = document.querySelector('.wizzy-product-count');

        if (summaryContainer) {
          const span = document.createElement('span');
          span.textContent = `${totalProducts} products`;

          summaryContainer.innerHTML = '';
          summaryContainer.appendChild(span);
        }
      }

      if (!document.body.classList.contains('wizzy-search-results-rendered')) {
        document.body.classList.add('wizzy-search-results-rendered');
      }

      /////////////////////////////////////////////////
      // Create the "Clear All" anchor element
      if((data.data.api === "search" || data.data.api === "filter")){
        var clearAllAnchor = document.createElement('a');
        clearAllAnchor.href = '#';
        clearAllAnchor.classList.add('wizzy-filters-clear-all', 'wiz');
        clearAllAnchor.textContent = 'Clear all filters';

        var selectedFacetList = document.querySelector('.wizzy-selected-facet-list');
        if (selectedFacetList) {
            selectedFacetList.appendChild(clearAllAnchor);
        }
      }

      ////////////////////////////////////////////////

      if(data.data.response.payload){
        if(data.data.response.payload.filters.origin === "SORT"){
          var desktopEntry = document.querySelector('.wizzy-filters-desktop-entry');
          if (desktopEntry) {
            desktopEntry.click();
          }
        }
      }

      ////////////////////////////////////////////////
      // Find the .wizzy-quick-filter element
      var quickFilter = document.querySelector('.wizzy-quick-filter');
      if (quickFilter && !quickFilter.textContent.trim()) {
          document.body.classList.add('quick-filter-empty');
      } else {
          document.body.classList.remove('quick-filter-empty');
      }
      if(quickFilter){
        const ulQuickFilter = quickFilter.querySelector(".wizzy-facet-list");
        const countQuickFilter = ulQuickFilter.childElementCount;
        // console.log(countQuickFilter, "wizzy childElementCount");
        if(countQuickFilter === 1){
          document.body.classList.add("single-filter-present");
        }else if(document.body.classList.contains("single-filter-present")){
          document.body.classList.remove("single-filter-present");
        }
      }

      ////////////////////////////////////////////////
      // Find the .wizzy-brand-quick-filter element
      var quickBrandFilter = document.querySelector('.wizzy-brand-quick-filter');
      if (quickBrandFilter && !quickBrandFilter.textContent.trim()) {
          document.body.classList.add('quick-brand-filter-empty');
      } else {
          document.body.classList.remove('quick-brand-filter-empty');
      }
      if(quickBrandFilter){
        const ulQuickBrandFilter = quickBrandFilter.querySelector(".wizzy-facet-list");
        const countBrandQuickFilter = ulQuickBrandFilter.childElementCount;
        // console.log(countBrandQuickFilter, "wizzy childElementCount");
        if(countBrandQuickFilter === 1){
          document.body.classList.add("single-brand-filter-present");
        }else if(document.body.classList.contains("single-brand-filter-present")){
          document.body.classList.remove("single-brand-filter-present");
        }
      }

      /////////////////////////////////////////////////////////////////////////////////

      const selectedOption = document.querySelector('.wizzy-common-select-option.selected');
      const applyBtn = document.querySelector('.wizzy-apply-btn');

      if (selectedOption && selectedOption.textContent.trim() !== 'Relevance') {
        if(applyBtn) {
          applyBtn.classList.add('active');
        }
      }
      
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      // console.log(payload,"PRODUCTS_CACHED_RESULTS_RENDERED");

      initializeButtonClicks();

      //////////////////////////////////////////////////////////////////////////////////////////////
      const productTypeFacet = document.querySelector('.wizzy-facet-list-block .wizzy-filters-facet-block[data-key="product_apparel_custom"]');
      const plpLeftPanel = document.querySelector('.wizzy-search-wrapper .wizzy-quick-filter');

      if (productTypeFacet && plpLeftPanel) {
        const clonedFacet = productTypeFacet.cloneNode(true);

        const facetHead = clonedFacet.querySelector('.wizzy-facet-head');
        const facetSearch = clonedFacet.querySelector('.facet-search-wrapper');
        if (facetHead) facetHead.remove();
        if(facetSearch) facetSearch.remove();

        plpLeftPanel.innerHTML = ''; // Clear existing content
        plpLeftPanel.appendChild(clonedFacet); // Append the cloned facet
      }

      //////////////////////////////////////////////////////////////////////////////////////////////

      const productTypeBrandFacet = document.querySelector('.wizzy-facet-list-block .wizzy-filters-facet-block[data-key="brands"]');
      const plpLeftBrandhPanel = document.querySelector('.wizzy-search-wrapper .wizzy-brand-quick-filter');

      if (productTypeBrandFacet && plpLeftBrandhPanel) {
        const clonedBrandFacet = productTypeBrandFacet.cloneNode(true);

        const facetBrandhHead = clonedBrandFacet.querySelector('.wizzy-facet-head');
        const facetBrandSearch = clonedBrandFacet.querySelector('.facet-search-wrapper');
        if (facetBrandhHead) facetBrandhHead.remove();
        if(facetBrandSearch) facetBrandSearch.remove();

        plpLeftBrandhPanel.innerHTML = ''; // Clear existing content
        plpLeftBrandhPanel.appendChild(clonedBrandFacet); // Append the cloned facet
      }

      const brandWrapper = document.querySelector('.wizzy-brand-quick-filter');
      if (brandWrapper) {
        const svgMap = {
          _ZODIAC: 'https://cdn.shopify.com/s/files/1/0958/7353/1977/files/ZODIAC_a938e0de-3f76-4cd2-b897-d4448e54158b.svg',
          _z3: 'https://cdn.shopify.com/s/files/1/0958/7353/1977/files/z3_1d5b0c77-698f-4163-989f-6969a5a13515.svg',
          _ZOD_: 'https://cdn.shopify.com/s/files/1/0958/7353/1977/files/ZOD_362dcfe0-9e73-4d88-967d-87a9cc59f9d1.svg'
        };

        Object.keys(svgMap).forEach(key => {
          const item = brandWrapper.querySelector(
            `.wizzy-facet-list-item[data-key="${key}"]`
          );

          if (item) {
            const label = item.querySelector('.wizzy-facet-list-item-label');

            if (label && !item.querySelector('.brand-svg')) {
              const img = document.createElement('img');
              img.src = svgMap[key];
              img.alt = key;
              img.className = 'brand-svg';
              // img.style.marginRight = '6px';
              // img.style.height = '16px';
              // img.style.verticalAlign = 'middle';

              label.prepend(img);
            }
          }
        });
      }

      const appliedFilter = document.querySelector(".wizzy-selected-filters");
      if(appliedFilter){
        if(appliedFilter.children.length > 0){
          const applyButton = document.querySelector(".wizzy-apply-btn");
          if(applyButton){
            applyButton.classList.add("active");
          }
        }else{
          console.log("No wizzy filter applied");
        }
      }

      setTimeout(() => {
        const productModals = document.querySelectorAll('product-modal');
        productModals.forEach(modal => {
          modal.remove();
        });
      }, 200);

      setTimeout(() => {
        const scrollTriggers = document.querySelectorAll('#MainContent .scroll-trigger');
        scrollTriggers.forEach(el => {
          if (el.classList.contains('animate--slide-in')) {
            el.classList.remove('animate--slide-in');
          }
        });
      }, 800);

      if (!document.body.classList.contains('wizzy-search-results-rendered')) {
        document.body.classList.add('wizzy-search-results-rendered');
      }

      /////////////////////////////////////////////////
      // Create the "Clear All" anchor element
      var clearAllAnchor = document.createElement('a');
      clearAllAnchor.href = '#';
      clearAllAnchor.classList.add('wizzy-filters-clear-all', 'wiz');
      clearAllAnchor.textContent = 'Clear all filters';

      var selectedFacetList = document.querySelector('.wizzy-selected-facet-list');
      if (selectedFacetList) {
          selectedFacetList.appendChild(clearAllAnchor);
      }

      ////////////////////////////////////////////////
      // Find the .wizzy-quick-filter element
      var quickFilter = document.querySelector('.wizzy-quick-filter');
      if (quickFilter && !quickFilter.textContent.trim()) {
          document.body.classList.add('quick-filter-empty');
      } else {
          document.body.classList.remove('quick-filter-empty');
      }
      if(quickFilter){
        const ulQuickFilter = quickFilter.querySelector(".wizzy-facet-list");
        const countQuickFilter = ulQuickFilter.childElementCount;
        // console.log(countQuickFilter, "wizzy childElementCount");
        if(countQuickFilter === 1){
          document.body.classList.add("single-filter-present");
        }else if(document.body.classList.contains('single-filter-present')){
          document.body.classList.remove("single-filter-present");
        }
      }

      ////////////////////////////////////////////////
      // Find the .wizzy-brand-quick-filter element
      var quickBrandFilter = document.querySelector('.wizzy-brand-quick-filter');
      if (quickBrandFilter && !quickBrandFilter.textContent.trim()) {
          document.body.classList.add('quick-brand-filter-empty');
      } else {
          document.body.classList.remove('quick-brand-filter-empty');
      }
      if(quickBrandFilter){
        const ulQuickBrandFilter = quickBrandFilter.querySelector(".wizzy-facet-list");
        const countBrandQuickFilter = ulQuickBrandFilter.childElementCount;
        // console.log(countBrandQuickFilter, "wizzy childElementCount");
        if(countBrandQuickFilter === 1){
          document.body.classList.add("single-brand-filter-present");
        }else if(document.body.classList.contains("single-brand-filter-present")){
          document.body.classList.remove("single-brand-filter-present");
        }
      }

      /////////////////////////////////////////////////////////////////////////////////

      const selectedOption = document.querySelector('.wizzy-common-select-option.selected');
      const applyBtn = document.querySelector('.wizzy-apply-btn');

      if (selectedOption && selectedOption.textContent.trim() !== 'Relevance') {
        if(applyBtn) {
          applyBtn.classList.add('active');
        }
      }
    
      return payload;
    }
  );


  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED, function(payload){
    // console.log("AFTER_WIZZY_API_RESPONDED", payload)

    // if (payload.response.payload.facets) {
    //   payload.response.payload.facets.forEach((facet) => {
    //     if (facet.key === "product_color_custom") {
    //       const ColorData = facet.data;
    //       if (ColorData) {
    //         ColorData.forEach(color => {
    //           if(colorMap[color.label]){
    //             color.isVisualSwatch = true;
    //             color.swatchValue = colorMap[color.label];
    //             color.isSwatch = true;
    //           }
    //           // console.log(color.isVisualSwatch, "Wizzy isVisualSwatch");
    //         });
    //         facet.data = ColorData;
    //       }
    //     }          
    //   });
    // }
    
    return payload
  })

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log(payload,"BEFORE_RENDER_RESULTS");

      if (payload.response.payload.facets) {
        payload.response.payload.facets.forEach((facet) => {
          if (facet.key === "product_color_custom") {
            const ColorData = facet.data;
            if (ColorData) {
              ColorData.forEach(color => {
                if(colorMap[color.label]){
                  color.isVisualSwatch = true;
                  color.isSwatch = true;
                  color.swatchValue = colorMap[color.label];
                }
                // console.log(color.isVisualSwatch, "Wizzy isVisualSwatch");
              });
              facet.data = ColorData;
            }
          }
          if(facet.key === "brands") {
            const brandData = facet.data;
            if (Array.isArray(brandData)) {
              const desiredOrder = ["z3", "ZODIAC", "ZOD!", "ZOD"];

              const sortedBrandData = brandData.sort((a, b) => {
                return desiredOrder.indexOf(a.key) - desiredOrder.indexOf(b.key);
              });
              facet.data = sortedBrandData;
              // console.log(sortedBrandData, "wizzy Brand data (sorted)");
            }
          }
          if(facet.key === "product_Size") {
            const sizedData = facet.data;
            if (Array.isArray(sizedData)) {
              // console.log(sizedData, "sizedData");
              facet.data = sizedData.sort((a, b) => {
                const getNumber = (val) => {
                  const match = val.match(/\d+/);
                  return match ? parseInt(match[0], 10) : Number.MAX_VALUE;
                };

                return getNumber(a.label) - getNumber(b.label);
              });
            }
          }
        });
      }
    
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return payload;
    }
  );

};






/////////////////////////////////////////////////////////////////////////////////

setTimeout(() => {
  initializeButtonClicks();
}, 1000);

function initializeButtonClicks() {
    // Check if the buttons have been initialized by looking for a specific class
    const closeBtn = document.querySelector('.wizzy-close-btn');
    if (closeBtn && !closeBtn.classList.contains('initialized')) {
        closeBtn.addEventListener('click', function() {
            const filtersBg = document.querySelector('.wizzy-filters-bg');
            if (filtersBg) {
                filtersBg.click();
            }
        });
        closeBtn.classList.add('initialized'); // Mark the button as initialized
        document.body.classList.contains('wizzy-filters-overlay') && document.body.classList.remove('wizzy-filters-overlay');
    }

    const applyBtn = document.querySelector('.wizzy-apply-btn');
    if (applyBtn && !applyBtn.classList.contains('initialized')) {
        applyBtn.addEventListener('click', function() {
            const filtersBg = document.querySelector('.wizzy-filters-bg');
            if (filtersBg) {
                filtersBg.click();
            }
        });
        applyBtn.classList.add('initialized'); // Mark the button as initialized
        document.body.classList.contains('wizzy-filters-overlay') && document.body.classList.remove('wizzy-filters-overlay');
    }
}



/////////////////////////////////////////// MUTATION OBSERVER  /////////////////////////////////////////////////////////////

const targetElement = document.querySelector('.shopify-section-header-sticky');

const handleClassChange = (mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      if (targetElement.classList.contains('scrolled-past-header')) {
        document.body.classList.add('wizzy-scrolled');
      } else {
        document.body.classList.remove('wizzy-scrolled');
      }
    }
  }
};

const observerScroll = new MutationObserver(handleClassChange);
const config = { attributes: true };

if (targetElement) {
  observerScroll.observe(targetElement, config);
} else {
  console.log('Target element not found!');
}

///////////////////////////////////////////////////

function isCollectionPage() {
  return window.location.pathname.startsWith("/collections/");
}

function isOnSearchPage() {
  return window.location.pathname.startsWith("/pages/search");
}

// Run on browser navigation (back/forward)
window.addEventListener("popstate", () => {
  if(isCollectionPage()){
    console.log("Hii Im on collection page");
    const wizzyDiv = document.querySelector('.wizzy-search-wrapper');
    if (wizzyDiv) {
      const scrollTriggerParent = wizzyDiv.closest('.scroll-trigger');
      if (scrollTriggerParent && !scrollTriggerParent.classList.contains('page-width')) {
        scrollTriggerParent.classList.add('page-width');
      }
      if(wizzyDiv && !wizzyDiv.classList.contains('wizzy-category-page')) {
        wizzyDiv.classList.add('wizzy-category-page');
      }

      const hero = document.querySelector('.collection-hero');
      if (hero) {
        // hero.remove();
        hero.style.display = 'block';
      }
    }

    setTimeout(() => {
      ////////////////////////////////////////////////
      var quickFilter = document.querySelector('.wizzy-quick-filter');
      if(quickFilter){
        const ulQuickFilter = quickFilter.querySelector(".wizzy-facet-list");
        const countQuickFilter = ulQuickFilter.childElementCount;
        // console.log(countQuickFilter, "wizzy childElementCount");
        if(countQuickFilter === 1){
          document.body.classList.add("single-filter-present");
        }else if(document.body.classList.contains("single-filter-present")){
          document.body.classList.remove("single-filter-present");
        }
      }

      ////////////////////////////////////////////////
      var quickBrandFilter = document.querySelector('.wizzy-brand-quick-filter');
      if(quickBrandFilter){
        const ulQuickBrandFilter = quickBrandFilter.querySelector(".wizzy-facet-list");
        const countBrandQuickFilter = ulQuickBrandFilter.childElementCount;
        // console.log(countBrandQuickFilter, "wizzy childElementCount brand");
        if(countBrandQuickFilter === 1){
          document.body.classList.add("single-brand-filter-present");
        }else if(document.body.classList.contains("single-brand-filter-present")){
          document.body.classList.remove("single-brand-filter-present");
        }
      }
    }, 500);

  }
  if(isOnSearchPage()){
    console.log("Hii Im on search page");
    const hero = document.querySelector('.collection-hero');
    if (hero) {
      hero.style.display = 'none';
    }

    setTimeout(() => {
      ////////////////////////////////////////////////
      var quickFilter = document.querySelector('.wizzy-quick-filter');
      if(quickFilter){
        const ulQuickFilter = quickFilter.querySelector(".wizzy-facet-list");
        const countQuickFilter = ulQuickFilter.childElementCount;
        // console.log(countQuickFilter, "wizzy childElementCount");
        if(countQuickFilter === 1){
          document.body.classList.add("single-filter-present");
        }else if(document.body.classList.contains("single-filter-present")){
          document.body.classList.remove("single-filter-present");
        }
      }

      ////////////////////////////////////////////////
      var quickBrandFilter = document.querySelector('.wizzy-brand-quick-filter');
      if(quickBrandFilter){
        const ulQuickBrandFilter = quickBrandFilter.querySelector(".wizzy-facet-list");
        const countBrandQuickFilter = ulQuickBrandFilter.childElementCount;
        // console.log(countBrandQuickFilter, "wizzy childElementCount brand");
        if(countBrandQuickFilter === 1){
          document.body.classList.add("single-brand-filter-present");
        }else if(document.body.classList.contains("single-brand-filter-present")){
          document.body.classList.remove("single-brand-filter-present");
        }
      }
    }, 500);

  }
});

/////////////////////////////////////////// MUTATION OBSERVER Two /////////////////////////////////////////////////////////////

const BODY_CLASS = 'wizzy-autocomplete-open';
const ROOT_WRAPPER_SELECTOR = '.wizzy-body-end-wrapper';
const AUTOCOMPLETE_SELECTOR = '.wizzy-autocomplete-wrapper';

let wizzyObserver = null;

function isDisplayFlex(autoComplete) {
  return autoComplete.style.display === 'flex';
}

function updateBodyClass(rootWrapper) {
  const autoComplete = rootWrapper.querySelector(AUTOCOMPLETE_SELECTOR);

  const shouldAddClass =
    autoComplete &&
    autoComplete.children.length > 0 &&
    isDisplayFlex(autoComplete);

  document.body.classList.toggle(BODY_CLASS, shouldAddClass);
}

function initWizzyObserver() {
  const rootWrapper = document.querySelector(ROOT_WRAPPER_SELECTOR);
  if (!rootWrapper) return;

  // Initial state check
  updateBodyClass(rootWrapper);

  wizzyObserver = new MutationObserver(() => {
    updateBodyClass(rootWrapper);
  });

  wizzyObserver.observe(rootWrapper, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });
}

// Call when DOM is ready or after Wizzy loads
setTimeout(() => {
  initWizzyObserver();
}, 500);


///////////////////////////////////////////////////////////////////////////////////////////

const trigger = document.querySelector('.header-icon-bar__item .mobile-search-trigger');

if (trigger) {
  trigger.addEventListener('click', function () {

    const scrollAmount = document.documentElement.scrollHeight * 0.010;
    window.scrollBy({
      top: -scrollAmount,
      behavior: "smooth" // optional (remove if you want instant scroll)
    });

    setTimeout(() => {
      const searchInput = document.querySelector('#Search-In-Modal');
      const searchOpen = document.querySelector('.header__search [open="true"]');
      
      if (searchInput && searchOpen) {
        searchInput.click();
        searchInput.focus();
      }
    }, 700);
  });
}
